import type { SignedInUser } from '@/lib/api/contracts'

/**
 * Kimlik ekranlarının yolları tek yerde.
 *
 * Yönlendirmelerde `navigate({ href })` kullanılır, `to` değil: route ağacı `app/router.tsx`'te
 * tanımlıdır ve tipli `to` yalnız orada kayıtlı yolları kabul eder. `href` aynı SPA gezinmesini
 * yapar ama sayfa bileşenlerini route tanımının şekline bağlamaz.
 */
export const authPaths = {
  login: '/login',
  forgotPassword: '/forgot-password',
  setPassword: '/set-password',
  changePassword: '/change-password',
  twoFactorSetup: '/two-factor-setup',
  portal: '/portal',
  admin: '/admin',
} as const

/** Oturum açıldıktan sonra kullanıcının düşeceği ekran. */
export function landingPathFor(user: SignedInUser): string {
  // Şifre değiştirmesi gereken kullanıcı başka hiçbir ucu kullanamaz: middleware kalan istekleri
  // 403 PASSWORD_CHANGE_REQUIRED ile keser (docs/spec/06-api-spec.md §Auth). Onu portala
  // yollamak, açılır açılmaz hata veren bir ekran göstermek olurdu.
  if (user.mustChangePassword) {
    return authPaths.changePassword
  }

  // Şifreden sonra sırada iki adımlı doğrulama var: ikisini birden borçlu bir hesap önce
  // şifresini belirler (sunucudaki ara katman sırası da böyle).
  if (user.twoFactorEnrolmentRequired) {
    return authPaths.twoFactorSetup
  }

  return user.role === 'SuperAdmin' ? authPaths.admin : authPaths.portal
}
